
import { defineComponent, inject, onMounted, ref } from "vue";
import { Chart, registerables } from "chart.js";
import { useStore } from "vuex";
import dayjs from "dayjs";
import "v-calendar/dist/style.css";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { useRoute, useRouter } from "vue-router";
Chart.register(...registerables);

export default defineComponent({
  name: "HomeView",
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    // ChevronDownIcon,
  },
  setup() {
    const axios: any = inject("$axios");
    let store = useStore();
    let route = useRoute();
    let router = useRouter();
    let date = ref(dayjs().format('YYYY-MM-DD'));
    let data = ref()
    let masks = ref({
      modelValue: 'YYYY-MM-DD',
    });

    onMounted(() => {
      if (route.params && route.params.date) {
        date.value = dayjs(Array.isArray(route.params.date) ? route.params.date[0] : route.params.date).format('YYYY-MM-DD')
      }
      getData();
    })

    const getData = async () => {
      return axios
        .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/dashboard/suspect", {
          operatorId: store.state.selectedOperator.operatorId,
          date: dayjs(date.value.toString()).format('YYYY-MM-DD'),
          userId: route.params.userId,
          page: 1,
          size: 100
        })
        .then(async (response: any) => {
          data.value = response.data.result;
          console.log(data.value);
          
          setTimeout(async () => {
            await getData()
          }, 60*1000);
        })
        .catch((err: any) => {
          console.log(err);
          return [];
        });
    };

    const fetchUser = async (username: string) => {
      const payload: any = {
        operatorId: store.state.selectedOperator.operatorId,
        filter: {
          username: username,
        },
        page: 0,
        pageSize: 5,
        sortBy: [["createdAt", -1]],
      };

      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/cms/user/list-pagination`;
      const { data } = await axios.post(url, payload)

      router.push({
        name: "Wallet Info",
        params: { id: data.result.data[0].id },
      });
    }

    const removeFromSuspect = async (payload: any, i:number) => {
      await axios.post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/dashboard/suspect/delete", {
        ...payload,
        username: payload.name,
        userId: payload.id,
        operatorId: store.state.selectedOperator.operatorId,
        date: dayjs(date.value.toString()).format('YYYY-MM-DD'),
      }).then((res: any) => {
        data.value.splice(i,1)
      })
    }

    const goBack = () => {
      router.push({
        name: "Realtime Dashboard Index", // หรือ "Realtime Dashboard"
        params: {
          date: date.value // ส่งค่า date ไปด้วย
        }
      });
    };

    return {
      removeFromSuspect,
      route,
      router,
      date,
      data,
      masks,
      getData,
      fetchUser,
      goBack
    };
  },
});
